
import Vue from 'vue';
import Component from 'vue-class-component';
import { BoListPanel } from 'bonomo/dist';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import { communityService } from '@/services/communityService';

@Component({
  name: 'RentbackList',
  components: { BoListPanel, PaginationBar },
})
export default class RentbackList extends Vue {
  private items: any[] = [];
  private currentPage: number = 1;
  private lastPage: number = 1;
  private total: number = 0;
  private perPage: number = 15;
  private selectedPerPage: number = 15;
  private search: string = '';
  private searchTimer: any = null;

  readonly perPageOptions: number[] = [15, 30, 50, 100];

  get headers() {
    return [
      { text: this.$t('common.community') as string, value: 'name', sortable: false },
      { text: this.$t('communities.fields.monthlyRentbackCredit') as string, value: 'rentback_credit', sortable: false },
      { text: this.$t('communities.fields.rentbackCap') as string, value: 'rentback_cap', sortable: false },
      { text: '', value: 'detailButton', sortable: false },
    ];
  }

  loadData() {
    this.fetchPage(1);
  }

  mounted() { /* loadData called by BoListPanel */ }

  private fetchPage(page: number) {
    const params: any = { page, per_page: this.selectedPerPage };
    if (this.search) params.search = this.search;
    communityService.fetchRentbackList(params).then((data: any) => {
      this.items = data.data || [];
      this.currentPage = data.current_page || 1;
      this.lastPage = data.last_page || 1;
      this.total = data.total || 0;
      this.perPage = data.per_page || this.selectedPerPage;
    });
  }

  onSearchInput() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => { this.fetchPage(1); }, 400);
  }

  onClearSearch() {
    this.search = '';
    this.fetchPage(1);
  }

  onPageChange(page: number) {
    this.fetchPage(page);
  }

  onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.fetchPage(1);
  }
}
